class MainHomepage extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.headerWrapper = null;
    this.desktopBreakpoint = 990;

    this.isDesktop = window.innerWidth >= this.desktopBreakpoint;
    this.originalSlides = [];
    this.handleResize = this.handleResize.bind(this);
    this.mouseSensitivity = this.dataset.mouseSensitivity;
    this.freeShippingObserver = null;
  }

  connectedCallback() {
    this.observeFreeShippingBanner();

    if (typeof Swiper !== 'undefined') {
      this.originalSlides = Array.from(this.querySelectorAll('.swiper-slide'));

      this.filterSlidesByBreakpoint();
      this.initializeSwiper();
      window.addEventListener('resize', this.handleResize);
      if (window.location.href.indexOf('ContactFooter') > -1) {
        const lastSlideIndex = this.swiper.slides.length - 1;
        this.swiper.slideTo(lastSlideIndex, 1000);
      }
    } else {
      console.error('Swiper library not loaded.');
    }
  }

  // FreeShippingBanner Mutation watcher
  observeFreeShippingBanner() {
    const target = document.body;
    if (!target) return;

    // If injected before observer starts
    if (document.getElementById('FreeShippingBanner')) {
      this.onFreeShippingBannerInjected();
      return;
    }

    this.freeShippingObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.id === 'FreeShippingBanner') {
            this.onFreeShippingBannerInjected();
            return;
          }
        }
      }
    });

    this.freeShippingObserver.observe(target, {
      childList: true,
      subtree: true,
    });
  }

  // Callback when banner appears
  onFreeShippingBannerInjected() {
    const stickyHeader = document.querySelector('sticky-header');
    const freeShippingBanner = document.getElementById('FreeShippingBanner');

    if (stickyHeader && freeShippingBanner) {
      console.log('FreeShippingBanner detected', { freeShippingBanner, stickyHeader });

      // Move the banner to be the first child of sticky-header
      stickyHeader.insertBefore(freeShippingBanner, stickyHeader.firstChild);

      // Stop observing after detection
      if (this.freeShippingObserver) {
        this.freeShippingObserver.disconnect();
        this.freeShippingObserver = null;
      }
    }
  }

  handleResize() {
    const currentIsDesktop = window.innerWidth >= this.desktopBreakpoint;

    if (currentIsDesktop !== this.isDesktop) {
      this.isDesktop = currentIsDesktop;

      this.destroySwiper();
      this.reinsertAllSlides();
      this.filterSlidesByBreakpoint();
      this.initializeSwiper();
    }
  }

  reinsertAllSlides() {
    const swiperWrapper = this.querySelector('.swiper-wrapper');
    if (!swiperWrapper) return;

    swiperWrapper.innerHTML = '';

    this.originalSlides.forEach((slide) => {
      swiperWrapper.appendChild(slide);
    });
  }

  filterSlidesByBreakpoint() {
    const isDesktop = window.innerWidth >= this.desktopBreakpoint;

    this.querySelectorAll('.swiper-slide').forEach((slide) => {
      const firstChild = slide.querySelector(':scope > :first-child');

      if (!firstChild) return;

      const shouldHideDesktop =
        firstChild.hasAttribute('data-slide-hide-desktop') &&
        firstChild.getAttribute('data-slide-hide-desktop') === 'true';

      const shouldHideMobile =
        firstChild.hasAttribute('data-slide-hide-mobile') &&
        firstChild.getAttribute('data-slide-hide-mobile') === 'true';

      if (isDesktop && shouldHideDesktop) {
        slide.remove();
      } else if (!isDesktop && shouldHideMobile) {
        slide.remove();
      }
    });
  }

  initializeSwiper() {
    const swiperContainer = this.querySelector('.swiper');
    this.headerWrapper = document.querySelector('.header-wrapper');

    if (!swiperContainer) {
      console.error('Swiper container not found inside <main-homepage>');
      return;
    }

    this.swiper = new Swiper(swiperContainer, {
      direction: 'vertical',
      grabCursor: true,
      speed: 400,
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
        thresholdDelta: this.mouseSensitivity,
      },
      keyboard: {
        enabled: true,
      },
      effect: 'creative',
      creativeEffect: {
        prev: {
          shadow: true,
          translate: [0, '0%', -1],
          opacity: 0,
        },
        next: {
          translate: [0, '100%', 0],
          opacity: 1,
        },
      },
    });

    this.swiper.on('slideChange', () => {
      const activeSlide = this.swiper.slides[this.swiper.activeIndex];
      let headerStyle = 'light';

      const contentBlock = activeSlide.querySelector('[data-header-style]');
      if (contentBlock) {
        headerStyle = contentBlock.getAttribute('data-header-style');
      }

      this.headerWrapper.classList.remove(
        'header-style-light',
        'header-style-dark',
        'header-style-default',
      );

      this.headerWrapper.classList.add(`header-style-${headerStyle}`);
    });

    setTimeout(() => {
      this.swiper.emit('slideChange');
    }, 0);
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  disconnectedCallback() {
    this.destroySwiper();

    window.removeEventListener('resize', this.handleResize);
    this.headerWrapper = null;
  }
}

customElements.define('main-homepage', MainHomepage);
